module.exports = __webpack_public_path__ + "static/assets/7231a404390e5fe96856a5ec5182745c.mp3";